import $ from 'jquery';
import _ from 'lodash';
import {
  GET_AUTOSUGGEST_DATA,
  GET_DATA,
  GET_TOTAL_PAGE_SIZE,
  GET_UNIQUE_DATA,
  HIDE_LOADING_SPINNER,
  SHOW_LOADING_SPINNER,
} from '../constants/actionTypes';

const initialState = {
  data: [],
  dataAutoSuggest: [],
  loading: false,
  totalDataSize: 0,
  dataUnique: [],
  isLogout: false,
};

function wrap(json) {
  if (Array.isArray(json)) {
    return json;
  }

  return [json];
}

function normalize(json, camelizeKeys) {
  const ret = [];

  wrap(json).forEach((elem) => {
    const type = camelizeKeys ? _.camelCase(elem.type) : elem.type;
    const obj = {};
    obj.type = type;
    obj.id = elem.id;

    if (camelizeKeys && elem.attributes) {
      Object.keys(elem.attributes).forEach((key) => {
        obj[_.camelCase(key)] = elem.attributes[key].trim();
      });
    } else if (elem.attributes) {
      Object.keys(elem.attributes).forEach((key) => {
        obj[key] =
          typeof elem.attributes[key] === 'string'
            ? elem.attributes[key].trim()
            : elem.attributes[key];
      });
    } else {
      Object.keys(elem).forEach((key) => {
        obj[key] = typeof elem[key] === 'string' ? elem[key].trim() : elem[key];
      });
    }

    if (elem.links) {
      obj.links = {};

      Object.keys(elem.links).forEach((key) => {
        obj.links[key] = elem.links[key];
      });
    }
    if (elem.relationships) {
      obj.relationships = $.extractRelationships(elem.relationships, { camelizeKeys });
    }
    ret.push(obj);
  });

  return ret;
}

function countTotalDataSize(data) {
  let totalDataSize = 0;
  const sizePerPage = 10;
  const pageNumber = 1;
  const pageSize = 1;

  if (data.meta) {
    if (data.data.length === 0 || data.data.length < pageSize) {
      totalDataSize = pageNumber * pageSize;
    } else {
      totalDataSize = data.meta.page_count * sizePerPage;
    }
  } else if (data.data) {
    totalDataSize = data.data.length;
  }

  return totalDataSize;
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_AUTOSUGGEST_DATA: {
      return {
        ...state,
        dataAutoSuggest: normalize(action.payload, null),
        loading: false,
      };
    }
    case GET_UNIQUE_DATA: {
      return {
        ...state,
        dataUnique: action.payload,
        loading: false,
      };
    }
    case GET_DATA: {
      return {
        ...state,
        data: normalize(action.payload, null),
        totalDataSize: countTotalDataSize(action.payload),
        loading: false,
      };
    }
    case GET_TOTAL_PAGE_SIZE: {
      return {
        ...state,
        totalDataSize: action.payload,
        loading: false,
      };
    }
    case SHOW_LOADING_SPINNER:
      return {
        ...state,
        data: action.payload,
        loading: true,
      };
    case HIDE_LOADING_SPINNER:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
